import { useRecoilValue } from "recoil";

import {
  PartnerViewSession,
  IsUserLoggedIn,
  UniqueIdentifierState,
  OverlayTriggerState,
  ViewLocationState,
  ViewSubLocationState,
} from "MVVM/State";
import { EViewLocations } from "MVVM/@types";

const isValidViewLocation = (loc: string): loc is EViewLocations =>
  Object.values(EViewLocations).includes(loc as EViewLocations);

export const useAnalyticsContext = (platform: string | null) => {
  const partnerViewSession = useRecoilValue(PartnerViewSession);
  const isLoggedIn = useRecoilValue(IsUserLoggedIn);
  const uniqueIdentifier = useRecoilValue(UniqueIdentifierState);
  const overlayTrigger = useRecoilValue(OverlayTriggerState);
  const viewLocation = useRecoilValue(ViewLocationState);
  const viewSubLocation = useRecoilValue(ViewSubLocationState);

  const referrer = document.referrer || null;
  const referring_domain = referrer ? new URL(referrer).hostname : null;

  const initial_referrer = localStorage.getItem("initial_referrer") || null;
  const initial_referring_domain = initial_referrer
    ? new URL(initial_referrer).hostname
    : null;

  const originatorType =
    partnerViewSession?.clip?.partner?.partnerId?.partnerId !== "Allstar"
      ? "allstar"
      : "partner";

  return {
    clip_clipId: partnerViewSession?.clip?.id,
    clip_clipType: "clip",
    clip_clipOwner: partnerViewSession?.clip?.user?._id,
    clip_playerGameIdentifier:
      partnerViewSession?.clip?.playerGameIdentifier ||
      partnerViewSession?.clip?.steamId64 ||
      partnerViewSession?.clip?.epicAccountId,
    clip_game: partnerViewSession?.clip?.game,
    clip_remix: partnerViewSession?.clip?.remix?.isRemixed,
    clip_partner: partnerViewSession?.overlayConfig?.partner?.name,
    clip_originatorType: originatorType,
    clip_partnerIdRequested:
      originatorType !== "partner"
        ? null
        : partnerViewSession?.clip?.partner?.partnerId?.defaultProfile,
    clip_useCase: partnerViewSession?.clip?.partner?.useCase,
    viewer_viewerIdentifier: uniqueIdentifier,
    viewer_viewerIsLoggedIn: isLoggedIn,
    viewer_viewerIsAllstar: partnerViewSession?.overlayConfig?.knownUser,
    viewLocation_platform: platform,
    viewLocation_location: viewLocation ? isValidViewLocation(viewLocation)
        ? viewLocation
        : "invalid"
      : undefined,
    viewLocation_subLocation: viewSubLocation ? isValidViewLocation(viewLocation)
        ? viewSubLocation
        : `${viewLocation}:${viewSubLocation}`
      : isValidViewLocation(viewLocation) ? undefined : viewLocation || undefined,
    overlayTrigger,
    path: window.location.pathname,
    search: window.location.search,
    referrer,
    referring_domain,
    initial_referrer,
    initial_referring_domain,
  };
};
